type ApiErrorPayload = {
  ok?: boolean;
  error?: string;
  message?: string;
};

function tryParseJson(raw: string): ApiErrorPayload | null {
  const s = String(raw || "").trim();
  if (!s.startsWith("{")) return null;
  try {
    const parsed = JSON.parse(s) as ApiErrorPayload;
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function friendlyProvisionError(raw: unknown): string {
  if (raw && typeof raw === "object") {
    const data = raw as ApiErrorPayload;
    const code = String(data.error || "").trim();
    const msg = String(data.message || "").trim();
    if (msg && !msg.startsWith("{")) return msg;
    switch (code) {
      case "domain_exists":
        return "This domain is already registered.";
      case "invalid_domain":
        return "Enter a valid domain name (e.g. example.com).";
      case "tenant_id_conflict":
        return "This domain could not be registered. Try again or contact support.";
      case "txt_not_verified":
        return "DNS verification record not found yet. Add the TXT record and try again.";
      case "a_record_not_ready":
        return "Point your domain A record to this server, then try again.";
      case "dns_failed":
        return "Could not resolve DNS for this domain yet.";
      case "not_found":
        return "Site not found.";
      case "forbidden":
        return "You do not have permission to do that.";
      default:
        break;
    }
  }

  if (typeof raw === "string") {
    const parsed = tryParseJson(raw);
    if (parsed) return friendlyProvisionError(parsed);
    if (raw.includes("domain_exists")) return "This domain is already registered.";
    if (raw.length > 160) return "Something went wrong. Please try again.";
    return raw;
  }

  return "Something went wrong. Please try again.";
}

export function deleteConfirmPhrase(domain: string): string {
  return `delete ${String(domain || "").trim().toLowerCase()}`;
}
